/*
export function someMutation (state) {
}
*/

export function SET_DASHBOARD(state, obj) {
  state.dashboard = obj;
}
